import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";
import { Users, Compass, Layers, Award, FolderTree, UserSquare2, BookOpen, Activity } from "lucide-react";

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);
    useEffect(() => { api.get("/admin/stats").then(r => setStats(r.data)); }, []);

    const cards = [
        { key: "users", label: "Usuários", icon: Users, accent: "from-[#007AFF]/15 to-[#00D4D4]/5" },
        { key: "journeys", label: "Jornadas", icon: Compass, accent: "from-[#9370DB]/15 to-[#FF00FF]/5" },
        { key: "modules", label: "Módulos", icon: Layers, accent: "from-[#00D4D4]/15 to-[#007AFF]/5" },
        { key: "certificates", label: "Certificados", icon: Award, accent: "from-[#D4AF37]/20 to-[#D4AF37]/5" },
        { key: "mentors", label: "Mentores", icon: UserSquare2, accent: "from-[#9370DB]/15 to-[#007AFF]/5" },
        { key: "categories", label: "Categorias", icon: FolderTree, accent: "from-[#00D4D4]/15 to-[#9370DB]/5" },
        { key: "ebooks", label: "E-books", icon: BookOpen, accent: "from-[#D4AF37]/15 to-[#00D4D4]/5" },
    ];

    const completion = stats?.progress_total
        ? Math.round((stats.progress_completed / stats.progress_total) * 100)
        : 0;

    return (
        <AdminLayout eyebrow="Visão geral" title="Dashboard">
            <section data-testid="admin-stats" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {cards.map(({ key, label, icon: Icon, accent }) => (
                    <div key={key} data-testid={`stat-${key}`} className={`p-6 rounded-2xl bg-gradient-to-br ${accent} border border-black/5`}>
                        <div className="flex items-center justify-between">
                            <div className="overline text-[#5C5C5C]">{label}</div>
                            <Icon className="w-5 h-5 text-[#1A1A1A]/60" />
                        </div>
                        <div className="font-display font-light text-5xl mt-3 tracking-tighter">
                            {stats ? stats[key] : "—"}
                        </div>
                    </div>
                ))}
            </section>

            <section className="grid md:grid-cols-2 gap-5 mt-8">
                <div data-testid="completion-card" className="p-7 rounded-2xl bg-white border border-black/5">
                    <div className="flex items-center justify-between">
                        <div className="overline text-[#5C5C5C]">Taxa de conclusão</div>
                        <Activity className="w-5 h-5 text-[#1A1A1A]/60" />
                    </div>
                    <div className="flex items-baseline gap-3 mt-4">
                        <div className="font-display font-light text-6xl tracking-tighter">{completion}%</div>
                        <div className="font-body text-sm text-[#5C5C5C]">
                            {stats?.progress_completed || 0} de {stats?.progress_total || 0} módulos
                        </div>
                    </div>
                    <div className="bar mt-5"><div style={{ width: `${completion}%` }} /></div>
                </div>

                <div className="p-7 rounded-2xl bg-[#1A1A1A] text-white border border-black/5">
                    <div className="overline text-white/60">Atalhos</div>
                    <div className="grid grid-cols-2 gap-3 mt-5">
                        <a href="/admin/jornadas" className="px-4 py-3 rounded-xl bg-white/10 hover:bg-white/15 font-display text-sm transition">+ Nova jornada</a>
                        <a href="/admin/mentores" className="px-4 py-3 rounded-xl bg-white/10 hover:bg-white/15 font-display text-sm transition">+ Novo mentor</a>
                        <a href="/admin/categorias" className="px-4 py-3 rounded-xl bg-white/10 hover:bg-white/15 font-display text-sm transition">+ Categoria</a>
                        <a href="/admin/planos" className="px-4 py-3 rounded-xl bg-white/10 hover:bg-white/15 font-display text-sm transition">Editar planos & e-books</a>
                        <a href="/admin/usuarios" className="px-4 py-3 rounded-xl bg-white/10 hover:bg-white/15 font-display text-sm transition">Gerenciar usuários</a>
                    </div>
                </div>
            </section>
        </AdminLayout>
    );
}
